<div class="confirm-autopay-details">
  <h4 class="subtitle" data-cy="autopay-details-subtitle">
    {{
      'i18n.payments.addBankAccountModal.autopayConfirmation.subtitle'
        | translate
    }}
  </h4>

  <section>
    <p
      *ngIf="autopayDetails.customers.length === 1; else multipleCustomers"
      data-cy="autopay-details-customers-field"
    >
      {{
        'i18n.payments.addBankAccountModal.autopayConfirmation.customer'
          | translate
      }}

      <strong data-cy="autopay-details-customer-field">
        {{ autopayDetails.customers[0].customerName | titlecase }} #{{
          autopayDetails.customers[0].customerNumber
        }}</strong
      >
    </p>
    <ng-template #multipleCustomers>
      <div class="multiple-customers" data-cy="autopay-details-customers-field">
        <p [class.show-all-customers]="showAllCustomers">
          {{
            'i18n.payments.addBankAccountModal.autopayConfirmation.customers'
              | translate
          }}
          {{ autopayDetails.customers.length }}
          <span (click)="showAllCustomers = !showAllCustomers"
            >{{
              'i18n.payments.addBankAccountModal.autopayConfirmation.seeAll'
                | translate
            }}
            <ion-icon
              [name]="
                showAllCustomers ? 'chevron-up-outline' : 'chevron-down-outline'
              "
            ></ion-icon
          ></span>
        </p>
        <ng-container *ngIf="showAllCustomers">
          <p *ngFor="let customer of autopayDetails.customers">
            {{ customer.customerName | titlecase }} #{{
              customer.customerNumber
            }}
          </p>
        </ng-container>
      </div>
    </ng-template>

    <p data-cy="autopay-details-bank-name-label">
      {{
        'i18n.payments.addBankAccountModal.autopayConfirmation.bankName'
          | translate
      }}
      <strong data-cy="autopay-details-bank-name-field">{{
        autopayDetails.bankName | titlecase
      }}</strong>
    </p>
    <p data-cy="autopay-details-account-number-label">
      {{
        'i18n.payments.addBankAccountModal.autopayConfirmation.accountNumber'
          | translate
      }}
      <strong data-cy="autopay-details-account-number-field" data-private
        >*****{{ autopayDetails.accountNumber | slice: -4 }}</strong
      >
    </p>
    <p data-cy="autopay-details-nickname-label">
      {{
        'i18n.payments.addBankAccountModal.autopayConfirmation.nickName'
          | translate
      }}
      <strong data-cy="autopay-details-nickname-field">{{
        autopayDetails.nickName || '-' | titlecase
      }}</strong>
    </p>
    <p data-cy="autopay-details-effective-date-label">
      {{
        'i18n.payments.addBankAccountModal.autopayConfirmation.effectiveDate'
          | translate
      }}
      <strong data-cy="autopay-details-effective-date-field">
        {{
          autopayDetails.autoDeductStartDate | date: 'MM/d/yyyy' : 'GMT'
        }}</strong
      >
    </p>
    <p data-cy="autopay-details-payment-made-label">
      {{
        'i18n.payments.addBankAccountModal.autopayConfirmation.paymentMadeOn'
          | translate
      }}
      <strong data-cy="autopay-details-payment-made-field">{{
        'i18n.payments.addBankAccountModal.autopayConfirmation.dueDate'
          | translate
      }}</strong>
    </p>
    <p data-cy="autopay-details-email-label">
      {{
        'i18n.payments.addBankAccountModal.autopayConfirmation.emailOnFile'
          | translate
      }}
      <strong data-cy="autopay-details-email-field"> {{ email }}</strong>
    </p>

    <ion-checkbox
      *ngIf="isDesktop; else mobileToggle"
      data-cy="autopay-details-include-notifications-email"
      mode="ios"
      justify="start"
      labelPlacement="end"
      [formControl]="emailNotificationControl"
    >
      <span class="email-notification-text">{{
        'i18n.payments.addBankAccountModal.autopayConfirmation.emailNotificationMsg'
          | translate
      }}</span>
    </ion-checkbox>

    <ng-template #mobileToggle>
      <ion-toggle
        [formControl]="emailNotificationControl"
        data-cy="autopay-details-include-notifications-email"
        labelPlacement="end"
        justify="start"
      >
        <span class="email-notification-text">{{
          'i18n.payments.addBankAccountModal.autopayConfirmation.emailNotificationMsg'
            | translate
        }}</span>
      </ion-toggle>
    </ng-template>

    <div
      data-cy="autopay-details-additional-message"
      [innerHTML]="
        'i18n.payments.addBankAccountModal.autopayConfirmation.additionalInformationMsg'
          | translate
      "
    ></div>

    <div data-cy="TOC" class="toc">
      <p data-cy="autopay-details-confirmation-field-message">
        {{
          'i18n.payments.addBankAccountModal.autopayConfirmation.confirmationFieldMsg'
            | translate
        }}
      </p>

      <ion-item>
        <ion-input
          [placeholder]="
            'i18n.payments.addBankAccountModal.autopayConfirmation.fullName'
              | translate
          "
          data-cy="autopay-details-full-name-input"
          [formControl]="fullNameControl"
        ></ion-input>
      </ion-item>

      <app-agreement-checkbox
        [agreementCheckboxControl]="
          confirmationAutopayForm.controls?.agreementCheckbox
        "
        [addBankAccountForm]="confirmationAutopayForm"
      ></app-agreement-checkbox>
    </div>
  </section>
</div>
